import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BrandHero from "./components/BrandHero";
import BrandStats from "./components/BrandStats";
import Testimonials from "./components/Testimonials";
import CooperationCTA from "./components/CooperationCTA";

const aboutJsonLd = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于我们 | 在线吃瓜官网",
  description:
    "在线吃瓜官网成立于2024年，是国内领先的娱乐八卦资讯聚合平台。致力于为吃瓜群众提供最新、最全、最真实的网红塌房和黑料爆料内容。",
  url: "https://zaixianchigua.com/about",
  about: {
    "@type": "Organization",
    name: "在线吃瓜官网",
    description:
      "国内领先的娱乐八卦资讯聚合平台，每日更新最新网红塌房、黑料爆料、吃瓜视频内容。",
    foundingDate: "2024",
  },
};

const breadcrumbJsonLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "首页",
      item: "https://zaixianchigua.com",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "关于我们",
      item: "https://zaixianchigua.com/about",
    },
  ],
};

export default function About() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />
      <main>
        <BrandHero />
        <BrandStats />
        <Testimonials />
        <CooperationCTA />
      </main>
      <Footer />
    </>
  );
}